/**
 * ResponsavelVisualizadorCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelVisualizador} from '@/model/resource/ResponsavelVisualizador'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelVisualizadorCollection extends PageCollection<
  ResponsavelVisualizador
> {
  constructor() {
    super(ResponsavelVisualizador)
  }

  queryAsPage() {
    return this.listResponsavelVisualizador()
  }

  async listResponsavelVisualizador() {
    return await Request.get(`/admin/responsavel-visualizador`, {
      params: this.params,
    })
      .name('listResponsavelVisualizador')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelVisualizador() {
    return await Request.get(`/admin/responsavel-visualizador/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelVisualizador')
      .as(this)
      .getResponse()
  }
}
